import { observable, makeObservable } from 'mobx'
import { OCRScopeWorkDto } from './dtos/ocr-scope-work'
import { Model } from 'infra/model'
import { maybeParseDate, DateZero } from 'utils/date-util'
import { Id } from 'types/definitions'
import once from 'lodash/once'

const lazyNone = once(() => new OCRScopeWork())

export default class OCRScopeWork extends Model<OCRScopeWorkDto, OCRScopeWork> {
  @observable archived = false
  @observable confidenceLevel = ''
  @observable createdById = ''
  @observable createdByName = ''
  @observable createdByUserPublicId = ''
  @observable dateCompleted = DateZero()
  @observable dateCreated = DateZero()
  @observable dateLastExecution = DateZero()
  @observable errorMessage = ''
  @observable fileName = ''
  @observable id = Id.none
  @observable jobId = Id.none
  @observable jobName = ''
  @observable legendId = Id.none
  @observable legendName = ''
  @observable legendVersion = 0
  @observable resolution = ''
  @observable status = ''
  @observable statusName = ''
  @observable teamId: string | null = null
  @observable templateId = Id.none
  @observable userId = Id.none
  @observable userName = ''
  @observable userPublicId = ''
  @observable workspaceId = Id.none
  @observable jobStatus = ''

  static get none() {
    return lazyNone()
  }

  constructor() {
    super()
    makeObservable(this)
  }

  parse(json: Partial<OCRScopeWorkDto>): Partial<OCRScopeWork> {
    return {
      archived: json.archived,
      confidenceLevel: json.confidence,
      createdById: json.created_by_id,
      createdByName: json.created_by_name,
      createdByUserPublicId: json.created_by_user_public_id,
      dateCompleted: maybeParseDate(json.date_completed),
      dateCreated: maybeParseDate(json.date_created),
      dateLastExecution: maybeParseDate(json.date_last_execution),
      errorMessage: json.error_message,
      fileName: json.file_name,
      id: json.id,
      jobId: json.job_id,
      jobName: json.job_name,
      legendId: json.legend_id,
      legendName: json.legend_name,
      legendVersion: json.legend_version,
      resolution: json.resolution,
      status: json.status,
      statusName: json.status_name,
      teamId: json.team_id,
      templateId: json.template_id,
      userId: json.user_id,
      userName: json.user_name,
      userPublicId: json.user_public_id,
      workspaceId: json.workspace_id,
      jobStatus: json.job_status,
    }
  }
}
